(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupCallDeleteController',FollowupCallDeleteController);

    FollowupCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'FollowupCall'];

    function FollowupCallDeleteController($uibModalInstance, entity, FollowupCall) {
        var vm = this;
        vm.followupCall = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FollowupCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
